module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__maje"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "woman",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/assets/imgs/case-study/maje/woman.png",
      "srcset": "/assets/imgs/case-study/maje/woman@2x.png 2x",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/assets/videos/case-study/maje/maje1.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/assets/videos/case-study/maje/maje2.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/assets/videos/case-study/maje/maje3.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/assets/videos/case-study/maje/maje4.mp4",
      "type": "video/mp4"
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("My work at maje")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n        During 1 year I worked as a freelance developer with Kaam&Roffler agency for Maje France. Before the season to come, I had a meeting at the Paris Maje headquarter with the digital creative team. They presented the design of the pages and we discussed the interactions that we had in mind. You can see some of them below.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d51ccd80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/CaseStudy/Maje.vue
// module id = 282
// module chunks = 0